
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import {RangeDatePickerInput, SingleDatePickerInput} from 'react-date-range-picker'
import  'react-date-range-picker/dist/main.css'

export const SingleAppDateTimePicker = ({
  label,
  enableTime,
  startDate,
  onChange
}) => {

  return <div>
    <SingleDatePickerInput
    onChange={(startDate)=>{
      onChange( dayjs(startDate).format("YYYY-MM-DDTHH:mm:ssZ") )
    }}
    enableTime = {enableTime} 
    label={label} 
    startDate={ startDate } 
    minDate={new Date(1970, 1, 1)} 
    dateFormat={enableTime ? "DD/MM/YYYY hh:mm a"  :"DD/MM/YYYY" } 
/>
  </div>

}
export const AppDateTimePicker = ({
  onChange,
  value,
  label,
  label2,
  enableTime
}) => { 
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  useEffect(()=> {
    if (startDate != null) {
      return
    }
    let now = new Date()
    let start = value.start  ? dayjs(value.start) : dayjs(now).subtract(1, 'months')
    let end = value.end  ? dayjs(value.end) : dayjs(now)
    setStartDate(start)
    setEndDate(end)
  },[value, startDate])
  
  if (startDate == null || endDate == null) {
    return null
  }
  return <div>
    <RangeDatePickerInput
    onChange={(startDate, endDate)=>{
      onChange({
        start: dayjs(startDate).format("YYYY-MM-DDTHH:mm:ssZ"),
        end: dayjs(endDate).format("YYYY-MM-DDTHH:mm:ssZ"),
      })
    }}
    enableTime = {enableTime}
    labelStart={label}
    labelEnd={label2} 
    startDate={ startDate }
  endDate={endDate} 
  minDate={new Date(1970, 1, 1)} 
  dateFormat={enableTime ? "DD/MM/YYYY hh:mm a"  :"DD/MM/YYYY" } 
/>
  </div>
}

 